// extracted by mini-css-extract-plugin
export default {"container":"DefaultView_container__AsaeO","text":"DefaultView_text__RwX+z","textLink":"DefaultView_textLink__tfj9X"};